import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom/dist";
import AddAddons from "../../core/modals/inventory/addaddons";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import { ChevronUp, PlusCircle } from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { setToogleHeader } from "../../core/redux/action";
import withReactContent from "sweetalert2-react-content";
import { useToast } from "../../Toaster/ToastContext";
import Loader from "../loader/loader";
import { apiClient } from "../../services/apiClient";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const AddonsList = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [addons, setAddons] = useState([]);
  const [filteredAddons, setFilteredAddons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAddons, setCurrentAddons] = useState(null);
  const { showToast } = useToast();
  const hasFetched = useRef(false);
  const [permissions, setPermissions] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    totalPages: 0,
    totalCount: 0,
  });

  useEffect(() => {
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
    try {
      const Permissions = JSON.parse(storedPermissions);
      const getPermissions = JSON.parse(Permissions.permissions);
      if (getPermissions.permissions) {
        parsedPermissions = getPermissions.permissions;
      } else {
        parsedPermissions = getPermissions;
      }

      const inventoryPermissions = parsedPermissions.find(
        (item) => item.title === "Inventory"
      );

      const productPermissions = inventoryPermissions?.childPage?.find(
        (child) => child.title === "Addons"
      );
      // console.log("search product", productPermissions)

      if (productPermissions) {
        setPermissions({
          create: productPermissions.create || false,
          read: productPermissions.read || false,
          update: productPermissions.update || false,
          delete: productPermissions.delete || false,
        });
      } else {
        console.error("Product permissions not found in localStorage");
        showToast(
          "Product permissions not found.",
          "error",
          "Permissions Error"
        );
      }
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      showToast("Failed to load permissions.", "error", "Permissions Error");
    }
  }, []);

  const fetchAddons = async (currentPage = 1, pageSize = 20, force = false) => {
    if (hasFetched.current && !force) return;
    setLoading(true);
    const pageIndex = currentPage - 1;
    try {
      const response = await apiClient.post("/paginate-addons", {
        pageIndex,
        pageSize,
      });
      const data = await response;
      if (data.success) {
        setAddons(data.data);
        setFilteredAddons(data.data);
        setPagination({
          currentPage: data.currentPage ?? currentPage,
          pageSize: data.pageSize ?? pageSize,
          totalPages: data.totalPages ?? 1,
          totalCount: data.totalCount || data.data.length,
        });
      } else {
        setAddons([]);
        setFilteredAddons([]);
      }
    } catch (error) {
      showToast(
        error.message || "Failed to fetch addons",
        "error",
        "Addons"
      );
    } finally {
      setLoading(false);
      hasFetched.current = true;
    }
  };

  // useEffect(() => {
  //   fetchAddons();
  // }, []);
  useEffect(() => {
    if (!hasFetched.current) {
      fetchAddons(pagination.currentPage, pagination.pageSize);
    }
  }, [pagination.currentPage, pagination.pageSize]);

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
    }));
    hasFetched.current = false;
  }, []);

  const handleAddAddons = () => {
    setCurrentAddons(null);
  };

  const handleEditAddons = (addons) => {
    setCurrentAddons(addons);
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setFilteredAddons(
      addons.filter(
        (addons) =>
          addons.name.toLowerCase().includes(term) ||
          addons.status.toLowerCase().includes(term)
      )
    );
  };

  const handleToggleStatus = async (addon) => {
    if (!permissions.update) {
      showToast(
        "You do not have permission to update addons.",
        "error",
        "Permissions Error"
      );
      return;
    }

    const newStatus = addon.status === "active" ? "inactive" : "active";
    try {
      setLoading(true);
      const response = await apiClient.post("/storeaddon", {
        id: addon.id,
        status: newStatus,
        name: addon.name,
        price: addon.price,
        image: addon.image,
      });
      if (response.status) {
        showToast(
          `Addon status updated to ${newStatus}`,
          "success",
          "Addon Operation"
        );
        // Update the local state to reflect the change
        setAddons((prev) =>
          prev.map((a) => (a.id === addon.id ? { ...a, status: newStatus } : a))
        );
        setFilteredAddons((prev) =>
          prev.map((a) => (a.id === addon.id ? { ...a, status: newStatus } : a))
        );
      } else {
        showToast(
          response.message || "Failed to update addon status",
          "error",
          "Addon Operation"
        );
      }
    } catch (error) {
      showToast(
        error.message || "Failed to update addon status",
        "error",
        "Addon Operation"
      );
    } finally {
      setLoading(false);
    }
  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="productimgname">
          <Link to="#" className="product-img stock-img">
            <ImageWithBasePath
              alt="Name"
              src={
                record.image ||
                "https://odabill.com/assets/img/product/noimage.png"
              }
            />
          </Link>
          <Link to="#">
            <span className="wrap-text">{record.name}</span>
          </Link>
        </span>
      ),
      sorter: (a, b) => a.name.length - b.name.length,
      width: 200,
    },

    {
      title: "Created On",
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at.length - b.created_at.length,
      render: (text) => {
        const date = new Date(text);
        return isNaN(date)
          ? "N/A"
          : date
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .split("/")
              .join("-");
      },
      width: 150,
    },

    // ✅ Only show Status column if read permission is true
    ...(permissions.read
      ? [
          {
            title: "Status",
            dataIndex: "status",
            render: (text, record) => (
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={text === "active"}
                  onChange={() => handleToggleStatus(record)}
                />
                <span className="toggle-slider"></span>
              </label>
            ),
            sorter: (a, b) => a.status.length - b.status.length,
            width: 100,
          },
        ]
      : []),

    // Actions column: only show if read OR delete permission
    ...(permissions.read || permissions.delete
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_, record) => (
              <td className="action-table-data">
                <div className="edit-delete-action">
                  {permissions.read && (
                    <Link
                      className="me-2 p-2"
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#add-addons"
                      onClick={() => handleEditAddons(record)}
                    >
                      <i data-feather="edit" className="feather-edit"></i>
                    </Link>
                  )}
                  {permissions.delete && (
                    <Link className="confirm-text p-2" to="#">
                      <i
                        data-feather="trash-2"
                        className="feather-trash-2"
                        onClick={() => showConfirmationAlert(record)}
                      ></i>
                    </Link>
                  )}
                </div>
              </td>
            ),
            width: 100,
          },
        ]
      : []),
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const response = await apiClient.post("/deleteaddon", {
            id: record.id,
          });
          const data = await response;
          if (data.status) {
            showToast(
              "Addons deleted successfully",
              "success",
              "Addons Operation!"
            );
            fetchAddons(pagination.currentPage, pagination.pageSize, true);
          } else {
            showToast(
              data.message || "Failed to delete addons",
              "error",
              "Addons Operation!"
            );
          }
        } catch (error) {
          showToast(
            error.message || "Failed to delete addons",
            "error",
            "Addons Operation!"
          );
        } finally {
          setLoading(false);
        }
      } else {
        MySwal.close();
      }
    });
  };

  const { currentPage, pageSize, totalPages, totalCount } = pagination;
  const startItem = totalCount > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(startItem + pageSize - 1, totalCount);

  const pagesToShow = [];
  if (totalPages > 0) {
    if (totalPages <= 2) {
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      let middle = [];
      if (currentPage === 1) {
        middle = [1, 2];
      } else if (currentPage === totalPages) {
        middle = [totalPages - 1, totalPages];
      } else {
        middle = [currentPage, currentPage + 1];
      }

      if (middle[0] > 1) {
        pagesToShow.push(1);
      }
      if (middle[0] > 2) {
        pagesToShow.push("...");
      }
      middle.forEach((p) => pagesToShow.push(p));
      if (middle[1] < totalPages - 1) {
        pagesToShow.push("...");
      }
      if (middle[1] < totalPages) {
        pagesToShow.push(totalPages);
      }
    }
  }

  const changePage = (page) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
    hasFetched.current = false;
  };

  return (
    <div>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Addons</h4>
                <h6>Manage your addons</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="page-btn">
              {permissions.create && (
                <Link
                  to="#"
                  className="btn btn-added"
                  data-bs-toggle="modal"
                  data-bs-target="#add-addons"
                  onClick={handleAddAddons}
                >
                  <PlusCircle className="me-2" />
                  Add New Addons
                </Link>
              )}
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search by name"
                      className="form-control form-control-sm formsearch"
                      onChange={handleSearch}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={filteredAddons}
                  rowKey={(record) => record.id}
                  rowSelection={null}
                  pagination={false}
                />
              </div>
              {totalCount > 0 && (
                <div className="custom-pagination d-flex justify-content-between align-items-center mt-4 mb-4">
                  <div className="pagination-left">
                    Showing {startItem} - {endItem} of {totalCount}
                  </div>
                  <div className="pagination-right d-flex align-items-center">
                    <button
                      className="btn btn-sm btn-outline-secondary me-2"
                      disabled={currentPage === 1}
                      onClick={() => changePage(currentPage - 1)}
                    >
                      <LeftOutlined size={12} />
                    </button>
                    {pagesToShow.map((page, index) => (
                      <span key={index} className="me-2">
                        {page === "..." ? (
                          <span className="pagination-ellipsis">...</span>
                        ) : (
                          <button
                            className={`btn btn-sm ${
                              page === currentPage
                                ? "btn-primary"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => changePage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </span>
                    ))}
                    <button
                      className="btn btn-sm btn-outline-secondary ms-2"
                      disabled={currentPage === totalPages}
                      onClick={() => changePage(currentPage + 1)}
                    >
                      <RightOutlined size={12} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <AddAddons
        addons={currentAddons}
        onSave={() => {
          hasFetched.current = false;
          fetchAddons(pagination.currentPage, pagination.pageSize);
        }}
      />
    </div>
  );
};

export default AddonsList;
